"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createDataQualityCellFormatter = void 0;
var React = require("react");
var DataQualityIndicatorStatusChip_1 = require("../../dataQualityIndicators/DataQualityIndicatorStatusChip");
var DataQualityStatusChip_1 = require("../../dataQualityWarnings/DataQualityStatusChip");
var DataQualityWarningFragments_1 = require("../../dataQualityWarnings/DataQualityWarningFragments");
var LayoutComponents_1 = require("../../style/LayoutComponents");
var SiteUrlsContext_1 = require("../../urls/SiteUrlsContext");
var CellStyles_1 = require("./CellStyles");
var IconCellDiv = LayoutComponents_1.divWithStyle('IconCell', __assign(__assign({}, CellStyles_1.cellPaddingStyle), { height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 24 }));
var DisabledIconCellDiv = LayoutComponents_1.divWithStyle('DisabledIconCell', __assign(__assign({}, CellStyles_1.cellPaddingStyle), { height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', width: 24, opacity: 0.6 }));
function DataQualityCell(props) {
    if (!props || !props.dataQualityWarnings || !props.dataQualityWarnings.some(function (w) { return w.isActive; })) {
        return null;
    }
    var details = DataQualityWarningFragments_1.mapActiveFragmentsOrIndicatorsToDetails(props.dataQualityWarnings, true, props.urls);
    if (details.length === 0) {
        return null;
    }
    return (props.disabled ? (React.createElement(DisabledIconCellDiv, null,
        React.createElement(DataQualityStatusChip_1.DataQualityStatusChip, { details: details, iconOnly: true, linksDisabled: props.linksDisabled || false, stackingRootId: props.stackingRootId, iconOnlyTabIndex: props.disableIconOnlyTabIndex ? -1 : 0 }))) : (React.createElement(IconCellDiv, null,
        React.createElement(DataQualityStatusChip_1.DataQualityStatusChip, { details: details, iconOnly: true, linksDisabled: props.linksDisabled || false, stackingRootId: props.stackingRootId, iconOnlyTabIndex: props.disableIconOnlyTabIndex ? -1 : 0 }))));
}
var IconStyle = {
    position: 'relative',
    left: '13.4px',
    top: '2px'
};
function convertDataQualityWarningsFromRowDataToIDataQualityIndicator(oldWarnings) {
    var newWarnings = oldWarnings === null || oldWarnings === void 0 ? void 0 : oldWarnings.map(function (warning) {
        var _a, _b, _c, _d, _e, _f;
        var owner = 'owner' in warning ? warning.owner : {
            authId: '',
            displayName: ((_a = warning.author) === null || _a === void 0 ? void 0 : _a.name) ? (_b = warning.author) === null || _b === void 0 ? void 0 : _b.name : '',
            username: ((_c = warning.author) === null || _c === void 0 ? void 0 : _c.username) ? (_d = warning.author) === null || _d === void 0 ? void 0 : _d.username : '',
            domainName: ((_e = warning.author) === null || _e === void 0 ? void 0 : _e.domain) ? (_f = warning.author) === null || _f === void 0 ? void 0 : _f.domain : '',
            id: '',
        };
        var newWarning = {
            isActive: warning.isActive,
            isSevere: warning.isSevere,
            type: 'type' in warning ? warning.type : warning.warningType,
            id: 'vizportalId' in warning ? warning.vizportalId : '',
            message: warning.message ? warning.message : '',
            updatedAt: new Date(warning.updatedAt),
            owner: owner,
        };
        return newWarning;
    });
    return newWarnings;
}
function convertDataQualityCertificationsFromRowDataToDataQualityIndicator(oldCertifications) {
    var newCertifications = oldCertifications === null || oldCertifications === void 0 ? void 0 : oldCertifications.map(function (certification) {
        var _a, _b, _c, _d, _e, _f;
        var owner = 'owner' in certification ? certification.owner : {
            authId: '',
            displayName: ((_a = certification.author) === null || _a === void 0 ? void 0 : _a.name) ? (_b = certification.author) === null || _b === void 0 ? void 0 : _b.name : '',
            username: ((_c = certification.author) === null || _c === void 0 ? void 0 : _c.username) ? (_d = certification.author) === null || _d === void 0 ? void 0 : _d.username : '',
            domainName: ((_e = certification.author) === null || _e === void 0 ? void 0 : _e.domain) ? (_f = certification.author) === null || _f === void 0 ? void 0 : _f.domain : '',
            id: '',
        };
        var newCertification = {
            isActive: certification.isActive,
            isSevere: true,
            type: 'CERTIFIED',
            id: 'vizportalId' in certification ? certification.vizportalId : '',
            message: certification.message ? certification.message : '',
            updatedAt: new Date(certification.updatedAt),
            owner: owner,
        };
        return newCertification;
    });
    return newCertifications;
}
function createDataQualityCellFormatter(opts) {
    var getWarningsFromRowData = opts.getWarningsFromRowData, getDisabledFromRowData = opts.getDisabledFromRowData, getChildWarningsFromRowData = opts.getChildWarningsFromRowData, linksDisabled = opts.linksDisabled, stackingRootId = opts.stackingRootId, disableIconOnlyTabIndex = opts.disableIconOnlyTabIndex, isCertification = opts.isCertification, rowDataFunctions = opts.rowDataFunctions;
    return function (props) {
        if (isCertification && rowDataFunctions) {
            var oldCertifications = rowDataFunctions.getDataQualityCertificationFromRowData(props.row.data);
            var newCertifications_1 = convertDataQualityCertificationsFromRowDataToDataQualityIndicator(oldCertifications);
            return (linksDisabled ?
                React.createElement("div", { style: IconStyle },
                    React.createElement(DataQualityIndicatorStatusChip_1.CertificationStatusChipOrIcon, { subjectArea: rowDataFunctions.getTypeNameFromRowData(props.row.data), kind: 'vizportal', anchoredAsset: {
                            assetName: rowDataFunctions.getNameFromRowData(props.row.data),
                            assetType: rowDataFunctions.getTypeNameFromRowData(props.row.data),
                            assetUrl: function (_) { return ''; },
                        }, anchoredCertifications: newCertifications_1 ? newCertifications_1 : [], iconOnly: true, linksDisabled: linksDisabled }))
                :
                    React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) { return (React.createElement("div", { style: IconStyle },
                        React.createElement(DataQualityIndicatorStatusChip_1.CertificationStatusChipOrIcon, { subjectArea: rowDataFunctions.getTypeNameFromRowData(props.row.data), kind: 'vizportal', anchoredAsset: {
                                assetName: rowDataFunctions.getNameFromRowData(props.row.data),
                                assetType: rowDataFunctions.getTypeNameFromRowData(props.row.data),
                                assetUrl: function (u) { return rowDataFunctions.getAssetUrlFromRowData(u, props.row.data); },
                            }, anchoredCertifications: newCertifications_1 ? newCertifications_1 : [], iconOnly: true, urls: linksDisabled ? undefined : urls, linksDisabled: linksDisabled }))); }));
        }
        else if (rowDataFunctions) {
            var oldWarnings = getWarningsFromRowData(props.row.data);
            var newWarnings_1 = convertDataQualityWarningsFromRowDataToIDataQualityIndicator(oldWarnings);
            var anchoredChildWarnings_1 = getChildWarningsFromRowData ? getChildWarningsFromRowData(props.row.data) : [];
            return (linksDisabled ?
                React.createElement("div", { style: IconStyle },
                    React.createElement(DataQualityIndicatorStatusChip_1.WarningStatusIcon, { iconOnly: true, kind: 'vizportal', upstreamWarnings: [], subjectArea: rowDataFunctions.getTypeNameFromRowData(props.row.data), anchoredAsset: {
                            assetName: rowDataFunctions.getNameFromRowData(props.row.data),
                            assetType: rowDataFunctions.getTypeNameFromRowData(props.row.data),
                            assetUrl: function (_) { return ''; },
                        }, anchoredChildWarnings: anchoredChildWarnings_1, anchoredWarnings: newWarnings_1 ? newWarnings_1 : [], linksDisabled: linksDisabled }))
                :
                    React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) { return (React.createElement("div", { style: IconStyle },
                        React.createElement(DataQualityIndicatorStatusChip_1.WarningStatusIcon, { iconOnly: true, kind: 'vizportal', upstreamWarnings: [], subjectArea: rowDataFunctions.getTypeNameFromRowData(props.row.data), anchoredAsset: {
                                assetName: rowDataFunctions.getNameFromRowData(props.row.data),
                                assetType: rowDataFunctions.getTypeNameFromRowData(props.row.data),
                                assetUrl: function (u) { return rowDataFunctions.getAssetUrlFromRowData(u, props.row.data); },
                            }, anchoredChildWarnings: anchoredChildWarnings_1, anchoredWarnings: newWarnings_1 ? newWarnings_1 : [], urls: linksDisabled ? undefined : urls, linksDisabled: linksDisabled }))); }));
        }
        if (linksDisabled) {
            return (React.createElement(DataQualityCell, { dataQualityWarnings: getWarningsFromRowData(props.row.data), disabled: getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false, linksDisabled: linksDisabled, stackingRootId: stackingRootId, disableIconOnlyTabIndex: disableIconOnlyTabIndex }));
        }
        else {
            return (React.createElement(SiteUrlsContext_1.SiteUrlsContext.Consumer, null, function (urls) { return (React.createElement(DataQualityCell, { dataQualityWarnings: getWarningsFromRowData(props.row.data), disabled: getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false, linksDisabled: linksDisabled, stackingRootId: stackingRootId, urls: urls, disableIconOnlyTabIndex: disableIconOnlyTabIndex })); }));
        }
    };
}
exports.createDataQualityCellFormatter = createDataQualityCellFormatter;
//# sourceMappingURL=QualityCellFormatter.js.map